import React from 'react';
import cn from 'classnames';

import Icon from '../Icon';
import './IconToggler.scss';

interface State {
    isOpen: boolean;
}

interface Props {
    onToggle: (flag: boolean) => any;
    isOpen?: boolean;
    glyphClose: {
        id: string;
        content: string;
        viewBox: string;
    };
    glyphOpen?: {
        id: string;
        content: string;
        viewBox: string;
    };
}

type Div = React.DOMAttributes<HTMLDivElement>;

export default class IconToggler extends React.Component<Props, State> {
    state: State = {
        isOpen: false,
    };

    UNSAFE_componentWillMount() {
        this.setState({
            isOpen: this.props.isOpen || false,
        });
    }

    handleToggle: Div['onClick'] = event => {
        event.stopPropagation();

        this.props.onToggle(!this.state.isOpen);

        this.setState(prevState => ({
            isOpen: !prevState.isOpen,
        }));
    };

    render() {
        const { isOpen } = this.state;
        const { glyphClose, glyphOpen } = this.props;

        return (
            <div
                styleName={cn('container', {
                    transformed: !isOpen && !glyphOpen,
                })}
                onClick={this.handleToggle}
            >
                <Icon
                    styleName="icon"
                    glyph={!isOpen && glyphOpen ? glyphOpen : glyphClose}
                    width={20}
                    height={20}
                />
            </div>
        );
    }
}
